// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"cd95e13e","703":"c5d824e8","787":"35f0dd8c","820":"eab57647"}[chunkId] + ".chunk.js";
};